import React from "react";

const BodyOne = props => {
  return <div className="body1">{props.text}</div>;
};

export default BodyOne;
